import { useState } from "react";
import "./login.css";
import { useAuth } from "../../hooks/AuthProvider";
import { Eye, EyeSlash } from "react-bootstrap-icons";

function Login() {
  const [input, setInput] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();

  const handleSubmitEvent = (e) => {
    e.preventDefault();
    if (input.email.trim() !== "" && input.password !== "") {
      login({
        email: input.email.trim(),
        password: input.password,
      });
      return;
    }
    alert("Please provide valid credentials");
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="loginContainer">
      <div className="loginLeftContainer">
        <div>
          <h1>Hey,</h1>
          <h1>Welcome back</h1>
          <h1>Admin!</h1>
        </div>
      </div>

      <div className="loginRightContainer">
        <div>
          <h1>Login</h1>
        </div>
        <form onSubmit={handleSubmitEvent}>
          <div className="userInput">
            <label>Email</label>
            <input
              placeholder="joe@solochat.me"
              type="email"
              aria-invalid="false"
              aria-describedby="user-email"
              name="email"
              value={input.email}
              onChange={handleInput}
              required
            />
          </div>
          <div className="userPassword">
            <label>Password</label>
            <div className="passwordInputWrapper">
              <input
                placeholder="Enter password"
                type={showPassword ? "text" : "password"}
                name="password"
                aria-invalid="false"
                aria-describedby="user-password"
                value={input.password}
                onChange={handleInput}
                required
              />
              <button
                type="button"
                className="passwordToggleBtn"
                onClick={() => setShowPassword((prev) => !prev)}
                title={showPassword ? "Hide password" : "Show password"}
                tabIndex="-1"
              >
                {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button type="submit" className="loginSubmitBtn">Log in</button>
        </form>
      </div>
    </div>
  );
}

export default Login;

